import { CompanyDepartmentRequest } from "../requests/CompanyDepartmentRequest";
import CompanyDepartment from "../CompanyDepartment";
import FormElement, { formElement } from "./FormElement";

export type CompanyDepartmentFormState = {
    name: FormElement<string>;
    isEnergyHarbourCustomer: FormElement<boolean>;
};

export function CompanyDepartmentFormState_default(): CompanyDepartmentFormState {
    return {
        name: formElement(""),
        isEnergyHarbourCustomer: formElement(false)
    };
}

export function CompanyDepartmentFormState_toRequest(formState: CompanyDepartmentFormState): CompanyDepartmentRequest {
    return {
        name: formState.name.value,
        isEnergyHarbourCustomer: formState.isEnergyHarbourCustomer.value
    };
}

export function CompanyDepartmentFormState_fromDepartment(department: Partial<CompanyDepartment>): CompanyDepartmentFormState {
    return {
        name: formElement(department.name ?? ""),
        isEnergyHarbourCustomer: formElement(department.isEnergyHarbourCustomer ?? false)
    };
}
